import { getFolderDeviationsWidgetConfig } from './widgets/FolderDeviations/widgetConfig';
import { getFoldersWidgetConfig } from './widgets/Folders/widgetConfig';

export const getGallectionWidgetConfigs = ({ t, dispatch }) => ({
  folders: getFoldersWidgetConfig({ t, dispatch }),
  folderDeviations: getFolderDeviationsWidgetConfig({ t, dispatch }),
});
